module.exports = __webpack_public_path__ + "static/img/rank_79.1b92370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_79.png
// module id = oVqm
// module chunks = 1